import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import {
  CandidateSearchFilters,
  ClassifyCandidateSearchFiltersRequest,
  HttpResponse,
} from "@/types";

export const useClassifyCandidateSearchFilters = () => {
  return useMutation({
    mutationFn: async (
      request: ClassifyCandidateSearchFiltersRequest,
    ): Promise<CandidateSearchFilters> => {
      const res = await guacHttpClient.post<
        CandidateSearchFilters,
        HttpResponse<CandidateSearchFilters>,
        ClassifyCandidateSearchFiltersRequest
      >("search/classify-filters", request);
      return res.data;
    },
  });
};
